// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'secondary', 'secondary Fallback'","fontWeight":700,"fontStyle":"normal"},"className":"__className_81acb3","variable":"__variable_81acb3"};